import { useState } from 'react';
import { API_CONFIG } from '../config/apiConfig';
import { apiClient } from '../utils/apiClient';

interface AuthorizeProblemSolverParams {
  userid: string;
}

interface AuthorizeProblemSolverResponse {
  success: boolean;
  data?: Array<{ authorizeProbleSolver: string }>;
  message?: string;
}

export const useAuthorizeProblemSolver = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const authorizeProblemSolver = async (params: AuthorizeProblemSolverParams): Promise<AuthorizeProblemSolverResponse | null> => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.AUTHORIZE_PROBLEM_SOLVER, {
        params
      });

      if (response.data.success) {
        return response.data;
      } else {
        setError(response.data.error || 'Authorization failed');
        return null;
      }
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || err.message || 'Failed to authorize problem solver';
      setError(errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    authorizeProblemSolver,
    loading,
    error
  };
};